import { useVpsHostingSectionContent } from './useVpsHostingSectionContent';
import { parseVpsHostingContinuityContent } from '../utils/vpsHostingContent';

export const useVpsHostingContinuityContent = () =>
  useVpsHostingSectionContent(parseVpsHostingContinuityContent);
